import { FC, PropsWithChildren } from "react";
import Logo from "@/components/Logo";
import Link from "next/link";
import BaseLayout, { LayoutProps } from "@/layouts/BaseLayout";

type Props = PropsWithChildren<
  {
    title: string;
  } & LayoutProps
>;

const VanillaLayout: FC<Props> = ({
  title,
  requiredAuth,
  children,
}): JSX.Element => {
  return (
    <BaseLayout requiredAuth={requiredAuth}>
      <header className="sticky top-0 shadow-lg bg-white px-16 py-8 z-10">
        <Link href={"/"}>
          <Logo width={207} height={56} />
        </Link>
      </header>
      <div className="bg-white px-16 py-64">
        <main className="max-w-[640px] mx-auto">
          <div className="grid gap-40">
            <h1 className="font-bold text-2xl">{title}</h1>
            <div>{children}</div>
          </div>
        </main>
      </div>
    </BaseLayout>
  );
};

export default VanillaLayout;
